import common from '../constants/common';

export default (status) =>
  common.statusPatients[status]
    ? common.statusPatients[status].label
    : 'Invalid status';
